<template>
  <div class="page-blog">
  <main>
      <section class="border-b border-gray-100 bg-gray-50">
        <div class="mx-auto max-w-[1400px] px-4 py-12 lg:px-8">
          <div class="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
            <div>
              <p class="text-xs font-semibold uppercase text-muted">Inspiration</p>
              <h1 class="text-3xl font-semibold text-ink sm:text-4xl">Ideas, checklists, and breakdowns for your day.</h1>
              <p class="text-sm text-muted">Clean, modern storytelling—just like an Airbnb trip guide.</p>
            </div>
            <div class="flex items-center gap-2 text-sm font-semibold">
              <button class="rounded-full border border-gray-200 px-4 py-2 text-ink transition hover:border-brand hover:text-brand">All</button>
              <button class="rounded-full border border-gray-200 px-4 py-2 text-ink transition hover:border-brand hover:text-brand">Venues</button>
              <button class="rounded-full border border-gray-200 px-4 py-2 text-ink transition hover:border-brand hover:text-brand">Planning</button>
              <button class="rounded-full border border-gray-200 px-4 py-2 text-ink transition hover:border-brand hover:text-brand">Photography</button>
            </div>
          </div>
        </div>
      </section>

      <section class="mx-auto max-w-[1400px] px-4 py-8 lg:px-8">
        <div class="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          <!-- Blog cards -->
          <article class="group h-full overflow-hidden rounded-3xl bg-white shadow-card ring-1 ring-gray-100 transition hover:-translate-y-1 hover:shadow-lg">
            <img class="h-48 w-full object-cover transition duration-300 group-hover:scale-105" src="https://dummyimage.com/640x420/fff6e8/1f2937" alt="Blog preview">
            <div class="space-y-3 p-5">
              <div class="flex items-center gap-2 text-xs text-muted">
                <span>6 min read</span>
                <span class="h-1 w-1 rounded-full bg-gray-300"></span>
                <span>by Invi8 Editors</span>
              </div>
              <h3 class="text-lg font-semibold text-ink group-hover:text-brand">10 sunset ceremony layouts guests actually love</h3>
              <p class="text-sm text-muted">String-light aisles, minimal florals, and seating maps that stay photo-ready.</p>
              <a class="inline-flex items-center gap-2 text-sm font-semibold text-brand hover:text-brandDark" href="/blog/sample-article">Read article →</a>
            </div>
          </article>
          <article class="group h-full overflow-hidden rounded-3xl bg-white shadow-card ring-1 ring-gray-100 transition hover:-translate-y-1 hover:shadow-lg">
            <img class="h-48 w-full object-cover transition duration-300 group-hover:scale-105" src="https://dummyimage.com/640x420/e7f3ff/1f2937" alt="Blog preview">
            <div class="space-y-3 p-5">
              <div class="flex items-center gap-2 text-xs text-muted">
                <span>4 min read</span>
                <span class="h-1 w-1 rounded-full bg-gray-300"></span>
                <span>by Laila (Planner)</span>
              </div>
              <h3 class="text-lg font-semibold text-ink group-hover:text-brand">Budget breakdowns couples wish they had sooner</h3>
              <p class="text-sm text-muted">Transparent vendor quotes and line items to keep you on track.</p>
              <a class="inline-flex items-center gap-2 text-sm font-semibold text-brand hover:text-brandDark" href="/blog/sample-article">Read article →</a>
            </div>
          </article>
          <article class="group h-full overflow-hidden rounded-3xl bg-white shadow-card ring-1 ring-gray-100 transition hover:-translate-y-1 hover:shadow-lg">
            <img class="h-48 w-full object-cover transition duration-300 group-hover:scale-105" src="https://dummyimage.com/640x420/fffaf0/1f2937" alt="Blog preview">
            <div class="space-y-3 p-5">
              <div class="flex items-center gap-2 text-xs text-muted">
                <span>7 min read</span>
                <span class="h-1 w-1 rounded-full bg-gray-300"></span>
                <span>by Aditi (Bride)</span>
              </div>
              <h3 class="text-lg font-semibold text-ink group-hover:text-brand">City rooftop, winery vibes: the best hybrid itineraries</h3>
              <p class="text-sm text-muted">Host ceremony downtown, celebrate sunset among the vines.</p>
              <a class="inline-flex items-center gap-2 text-sm font-semibold text-brand hover:text-brandDark" href="/blog/sample-article">Read article →</a>
            </div>
          </article>
          <article class="group h-full overflow-hidden rounded-3xl bg-white shadow-card ring-1 ring-gray-100 transition hover:-translate-y-1 hover:shadow-lg">
            <img class="h-48 w-full object-cover transition duration-300 group-hover:scale-105" src="https://dummyimage.com/640x420/e6f8ef/1f2937" alt="Blog preview">
            <div class="space-y-3 p-5">
              <div class="flex items-center gap-2 text-xs text-muted">
                <span>5 min read</span>
                <span class="h-1 w-1 rounded-full bg-gray-300"></span>
                <span>by Invi8 Editors</span>
              </div>
              <h3 class="text-lg font-semibold text-ink group-hover:text-brand">5 design-forward floral palettes</h3>
              <p class="text-sm text-muted">From citrus pops to minimalist whites, see what photographs best.</p>
              <a class="inline-flex items-center gap-2 text-sm font-semibold text-brand hover:text-brandDark" href="/blog/sample-article">Read article →</a>
            </div>
          </article>
          <article class="group h-full overflow-hidden rounded-3xl bg-white shadow-card ring-1 ring-gray-100 transition hover:-translate-y-1 hover:shadow-lg">
            <img class="h-48 w-full object-cover transition duration-300 group-hover:scale-105" src="https://dummyimage.com/640x420/f2f7ff/1f2937" alt="Blog preview">
            <div class="space-y-3 p-5">
              <div class="flex items-center gap-2 text-xs text-muted">
                <span>8 min read</span>
                <span class="h-1 w-1 rounded-full bg-gray-300"></span>
                <span>by Jess (Photographer)</span>
              </div>
              <h3 class="text-lg font-semibold text-ink group-hover:text-brand">Getting the most from your photo timeline</h3>
              <p class="text-sm text-muted">Golden hour portraits, family formals, and contingency plans.</p>
              <a class="inline-flex items-center gap-2 text-sm font-semibold text-brand hover:text-brandDark" href="/blog/sample-article">Read article →</a>
            </div>
          </article>
          <article class="group h-full overflow-hidden rounded-3xl bg-white shadow-card ring-1 ring-gray-100 transition hover:-translate-y-1 hover:shadow-lg">
            <img class="h-48 w-full object-cover transition duration-300 group-hover:scale-105" src="https://dummyimage.com/640x420/fff6ff/1f2937" alt="Blog preview">
            <div class="space-y-3 p-5">
              <div class="flex items-center gap-2 text-xs text-muted">
                <span>4 min read</span>
                <span class="h-1 w-1 rounded-full bg-gray-300"></span>
                <span>by Invi8 Editors</span>
              </div>
              <h3 class="text-lg font-semibold text-ink group-hover:text-brand">Welcome dinner ideas that feel effortless</h3>
              <p class="text-sm text-muted">Family-style feasts, playlists, and decor that sets the tone.</p>
              <a class="inline-flex items-center gap-2 text-sm font-semibold text-brand hover:text-brandDark" href="/blog/sample-article">Read article →</a>
            </div>
          </article>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
export default {
  name: 'BlogView'
}
</script>
